<template>
  <v-app>

    <v-navigation-drawer
      v-model="drawer"
      temporary
      app
      id = "drawer"
      right
    >
    <v-list dense nav>
        <v-list-item link to="/">
          <v-list-item-icon><v-icon>home</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Home</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item link to="/about">
          <v-list-item-icon><v-icon>info</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>About</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item link to="/settings">
          <v-list-item-icon><v-icon>build</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Settings</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dense>
      <v-toolbar-title class="headline">
        <span>SenTiLab</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"><v-icon>menu</v-icon></v-app-bar-nav-icon>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn to="/" text><v-icon left>home</v-icon>Home</v-btn>
        <v-btn to="/about" text><v-icon left>info</v-icon>About</v-btn>
        <v-btn to="/settings" text><v-icon left>build</v-icon>Settings</v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <v-content>
      <router-view/>
    </v-content>
    <v-footer height="auto" class="pa-0">
      <v-card class=" text-xs-center" width="100%">
        <v-card-text align="center">
          &copy;2019 — <strong>6 Wolves</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',
  components: {
    HelloWorld,
  },
  data() {
    return {
      drawer: null,
    };
  },
};
</script>
